export enum CsszSickNoteStateEnum {
    NEW = 'NEW', // Tento stav neni v CSSZ - z pohledu CSSZ pripad jeste neexistuje (neni zpracovan)
    OTV = 'OTV',
    RZP = 'RZP',
    UKC = 'UKC',
    STR = 'STR',
    STP = 'STP',
}
